import { render, staticRenderFns } from "./AddTokenDialog.vue?vue&type=template&id=a7d37f9c&"
import script from "./AddTokenDialog.vue?vue&type=script&lang=js&"
export * from "./AddTokenDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports